import { StyleProps, ThemingProps, useStyleConfig } from "@chakra-ui/react";
import { chakra } from "@chakra-ui/system";

export const DescriptionList: React.FC<
  React.PropsWithChildren<ThemingProps>
> = (props) => {
  const styles = useStyleConfig("DescriptionList", props);
  return <chakra.dl sx={styles} {...props} />;
};

export interface DescriptionListItemProps extends StyleProps {
  term: string;
}

export const DescriptionListItem: React.FC<
  React.PropsWithChildren<DescriptionListItemProps>
> = ({ term, children }) => (
  <>
    <chakra.dt>{term}</chakra.dt>
    <chakra.dd>{children}</chakra.dd>
  </>
);
